/**
 * CPF formatado (000.000.000-00).
 *
 * A coluna do banco aceita 14 caracteres. Com o campo livre, um dígito ou pontuação a mais
 * estourava o limite e o servidor recusava o envio inteiro da ficha — mascarar resolve na
 * origem, porque o valor nunca passa de 14.
 */
export const mascaraCpf = (v) => {
  const d = (v || "").replace(/\D/g, "").slice(0, 11);
  if (d.length <= 3) return d;
  if (d.length <= 6) return `${d.slice(0, 3)}.${d.slice(3)}`;
  if (d.length <= 9) return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6)}`;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
};
